import { InjectionToken } from '@angular/core';

export const APP_KEY = new InjectionToken<string>('APP_KEY');
